import {Table} from "react-bootstrap";
import React from "react";

export default function TimeTable(props) {
    // console.log(props.opening_hours);
    const opening_hours = props.opening_hours;
    return (
        <Table borderless size="sm">
            <tbody>
                { opening_hours.sunday.open &&
                <tr>
                    <td>Sun</td>
                    <td>{opening_hours.sunday.from} </td>
                    <td>-</td>
                    <td>{opening_hours.sunday.to} </td>
                </tr>
                }
                { opening_hours.monday.open &&
                <tr>
                    <td>Mon</td>
                    <td>{opening_hours.monday.from} </td>
                    <td>-</td>
                    <td>{opening_hours.monday.to} </td>
                </tr>
                }
                { opening_hours.tuesday.open &&
                <tr>
                    <td>Tue</td>
                    <td>{opening_hours.tuesday.from} </td>
                    <td>-</td>
                    <td>{opening_hours.tuesday.to} </td>
                </tr>
                }
                { opening_hours.wednesday.open &&
                <tr>
                    <td>Wed</td>
                    <td>{opening_hours.wednesday.from} </td>
                    <td>-</td>
                    <td>{opening_hours.wednesday.to} </td>
                </tr>
                }
                { opening_hours.thursday.open &&
                <tr>
                    <td>Thu</td>
                    <td>{opening_hours.thursday.from} </td>
                    <td>-</td>
                    <td>{opening_hours.thursday.to} </td>
                </tr>
                }
                { opening_hours.friday.open &&
                <tr>
                    <td>Fri</td>
                    <td>{opening_hours.friday.from} </td>
                    <td>-</td>
                    <td>{opening_hours.friday.to} </td>
                </tr>
                }
                { opening_hours.saturday.open &&
                <tr>
                    <td>Sat</td>
                    <td>{opening_hours.saturday.from} </td>
                    <td>-</td>
                    <td>{opening_hours.saturday.to} </td>
                </tr>
                }
            </tbody>
        </Table>
    )
}